import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Toast, ToastContainer, Spinner } from "react-bootstrap";
import ModalCloseIcon from "../../assets/svg/close-modal.svg";
import issue from "../../assets/svg/issue.svg";
import { getReportIssueTypeApi, reportAnIssueApi } from "./common-api";
import "./report-an-issue.css";

export const ReportAnIssueButton = ({ onSuccess }) => {
  const [showModal, setShowModal] = useState(false);

  const handleSuccess = (data) => {
    setShowModal(false);
    if (onSuccess) {
      onSuccess(data);
    }
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  return (
    <>
      <button
        onClick={() => {
          setShowModal(true);
        }}
        type="button"
        className="right_divs px-2"
        style={{
          width: "152px",
          height: "36px",
          display: "flex",
          alignItems: "center",
          columnGap: "8px",
          fontSize: "13px",
          border: "none",
          borderRadius: "12px",
          backgroundColor: "#F8F8F8",
          color: "#172B4D",
          fontWeight: "500",
        }}
      >
        <img src={issue} alt="issue" srcSet="" style={{ width: "20px", height: "20px", cursor: "pointer" }} />
        <span>Report an issue</span>
      </button>

      {showModal && <ReportAnIssueModal onSuccess={handleSuccess} onCancel={handleCancel} />}
    </>
  );
};

const ReportAnIssueModal = ({ onSuccess, onCancel }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [validations, setvalidations] = useState({
    description: "",
    title: "",
    type: "",
  });
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",

      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "680px",

      overflowY: "auto",
    },
  };
  useEffect(() => {
    getReportIssueType();
  }, []);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [rejectReason, setRejectReason] = useState("");
  const [scheduleDate, setScheduleDate] = useState("");
  const [scheduleTime, setScheduleTime] = useState("");
  const [title, setTitle] = useState("");
  const [issueTypeList, setIssueTypeList] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastStatus, setToastStatus] = useState(null);
  const [isReportLoading, setIsReportLoading] = useState(false);
  const handleChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const getReportIssueType = async () => {
    const response = await getReportIssueTypeApi();
    if (response.success === true) {
      const types = response.data ?? [];
      setIssueTypeList(types);
      if (types.length > 0) {
        setSelectedStatus(types[0].label);
      }
    } else {
    }
  };
  const reportIssue = async () => {
    const payload = {
      application: "Dock",
      type: selectedStatus,
      title: title,
      description: rejectReason,
    };
    setIsReportLoading(true);
    try {
      const response = await reportAnIssueApi(payload);
      if (response && response.status === 400) {
        setvalidations({
          description: response.data.error?.description?.[0] || "",
          title: response.data.error?.title?.[0] || "",
          type: response.data.error?.type?.[0] || "",
        });
      } else {
        if (response && response.data.success === true) {
          setToastMessage(response.data.message || "Report submitted successfully!");
          setToastStatus(true);
          setShowToast(true);
          // Reset form
          setTitle("");
          setRejectReason("");
          setSelectedStatus(issueTypeList.length > 0 ? issueTypeList[0].label : "");
          setvalidations({ description: "", title: "", type: "" });
          // Close modal after delay
          setTimeout(() => {
            onSuccess(response.data);
          }, 1500);
        } else {
          setToastMessage(response?.data?.message || "Failed to submit report");
          setToastStatus(false);
          setShowToast(true);
        }
      }
      return response?.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsReportLoading(false);
    }
  };

  return (
    <div style={modalStyle.overlay}>
      <div style={modalStyle.modal}>
        <div style={{ color: "#ffffff" }}>
          <div>
            <div className="px-3 py-3 d-flex align-items-center justify-content-between" style={{ borderBottom: "1px solid #EBEBEB" }}>
              <div className="fs-18 fw-600" style={{ color: "#21272C" }}>
                Report a problem
              </div>
              <img
                src={ModalCloseIcon}
                alt="Close"
                onClick={onCancel}
                style={{
                  cursor: "pointer",
                  width: "24px",
                  height: "24px",
                }}
              />
            </div>
            <div className="px-3 pb-3 pt-3">
              <div className="form-label fs-14 fw-400 mb-1" style={{ color: "#21272C" }}>
                Issue Type
              </div>
              <div className="style-justify-start" style={{ flexWrap: "wrap", gap: "8px" }}>
                {issueTypeList.map((type, index) => (
                  <label className={`${selectedStatus === type.label ? "radio-btn-txt-active" : "radio-btn-txt-inactive"}`}>
                    <input type="radio" name="options" value={type.label} checked={selectedStatus === type.label} onChange={handleChange} className="custom-radio" />
                    <span className={`px-2 ${selectedStatus === type.label ? "radio-btn-txt-active" : "radio-btn-txt-inactive"}`}>{type.label}</span>
                  </label>
                ))}
              </div>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#FF4444",
                }}
              >
                {validations.type}
              </span>

              <div>
                <div className="form-label fs-14 fw-400 mb-1 mt-2" style={{ color: "#21272C" }}>
                  Title
                </div>
                <div>
                  <input
                    type="text"
                    placeholder="Enter here"
                    className="form-control rounded-3 w-100"
                    value={title}
                    onChange={(event) => {
                      setTitle(event.target.value);
                    }}
                  />
                  {/* <span className="field-error">{validations.reason}</span> */}
                </div>
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                  }}
                >
                  {validations.title}
                </span>
              </div>

              <div>
                <div className="form-label fs-14 fw-400 mb-1 mt-2" style={{ color: "#21272C" }}>
                  Explain your problem
                </div>
                <div>
                  <textarea
                    type="text"
                    placeholder=" "
                    className="form-control rounded-3 w-100"
                    value={rejectReason}
                    onChange={(event) => {
                      setRejectReason(event.target.value); // Update state with input value
                    }}
                  />
                  {/* <span className="field-error">{validations.reason}</span> */}
                </div>
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                  }}
                >
                  {validations.description}
                </span>
              </div>

              <div className="mt-3">
                <div className="d-flex align-items-center justify-content-end gap-3">
                  <div
                    onClick={onCancel}
                    className="d-flex align-items-center justify-content-center px-4 py-2 rounded-pill"
                    style={{
                      border: "1px solid #EBEBEB",
                      backgroundColor: "#ffffff",
                      color: "#21272C",
                      fontSize: "14px",
                      fontWeight: "500",
                      cursor: "pointer",
                      minWidth: "100px",
                    }}
                  >
                    Cancel
                  </div>

                  <div
                    onClick={() => {
                      if (!isReportLoading) reportIssue();
                    }}
                    className="issue-submit-btn style-justify-center px-4"
                    style={{
                      opacity: isReportLoading ? 0.6 : 1,
                      pointerEvents: isReportLoading ? "none" : "auto",
                      cursor: isReportLoading ? "not-allowed" : "pointer",
                      gap: "8px",
                    }}
                  >
                    {isReportLoading && <Spinner animation="border" size="sm" variant="light" />}
                    Send report
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Toast Notification */}
      <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
        <Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide bg={toastStatus === true ? "success" : "danger"}>
          <Toast.Body className="text-white">{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default ReportAnIssueModal;
